import React, { Component } from 'react'

export default class RowItemThanhTraDeXuat extends Component {
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.doiTuong || ''}</td>
        <td>{this.props.item.yKien || ''}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemThanhTraDeXuat.jsx